<template>
  <div>
    <template v-if="slide.image.length">
      <p><img :src="'/uploads/images/main_slider/' + slide.image" alt=""></p>
      <p><a @click="deleteImage">Удалить изображение</a></p>
    </template>
    <BaseImageUpload
        label="Изображение слайда"
        :error="slideImageError"
        @onFileChange="handleImage"
    ></BaseImageUpload>

    <BaseInput
      label="Текст 1"
      v-model="$parent.slides[slideIndex].text1"
      @onChange="$parent.saveData()"
    ></BaseInput>
    <BaseInput
        label="Текст 2"
        v-model="$parent.slides[slideIndex].text2"
        @onChange="$parent.saveData()"
    ></BaseInput>
    <BaseInput
        label="Ссылка"
        v-model="$parent.slides[slideIndex].link"
        @onChange="$parent.saveData()"
    ></BaseInput>
    <SearchAutocomlete
        label="Конкурс"
        :items="$parent.competitions"
        searchKey="name"
        parentResultKey="competition"
        :defaultvalue="slide.competition?.name"
    ></SearchAutocomlete>
  </div>
</template>

<script>
import BaseImageUpload from "@/components/Base/BaseImageUpload";
import BaseInput from "@/components/HomeSlider/BaseInput";
import SearchAutocomlete from "@/components/HomeSlider/SearchAutocomlete";

export default {
  name: "SlideForm",
  props: [
      "slide",
      "slideIndex"
  ],
  data() {
    return {
      slideImageError: "",
      competition: null
    }
  },
  components: {
    BaseImageUpload,
    BaseInput,
    SearchAutocomlete
  },
  watch: {
    competition(newValue) {
      this.$parent.slides[this.slideIndex].competition = newValue;
      this.$parent.saveData();
    }
  },
  methods: {
    deleteImage() {
      this.handleImage('');
    },
    handleImage(file) {
      const self = this;
      this.uploadImage(file).then((data) => {
        self.slideImageError = "";
        self.$parent.slides[self.slideIndex].image = data.fileName;
        self.$parent.saveData();
      })
      .catch((error) => {
        console.log(error);
        self.slideImageError = error.responseJSON.detail;
      });
    },
    uploadImage(file) {
      return new Promise((resolve, reject) => {
        var form_data = new FormData();
        form_data.append('file', file);
        form_data.append('existingFilename', this.slide.image);
        form_data.append('entityName', 'main_slider');

        window.$.ajax({
          dataType: "json",
          contentType: false,
          processData: false,
          type : 'post',
          data: form_data,
          url: '/uploadImage',
          success: function(data) {
            resolve(data);
          },
          error: function(data) {
            reject(data)
          }
        });
      })

    }
  }
}
</script>

<style scoped>

</style>